import { useMutation } from '@apollo/client';
import { Typography, notification } from 'antd';
import React, { useCallback, useState } from 'react';
import YesNoModalJ10 from '@aims/shared/components/YesNoModalJ10';
import { deleteTrainingFileMutation } from './constants';

const { Paragraph } = Typography;

function DeleteTrainingFileModal({ visible, onCancel, onFinish }) {
  const trainingFile = visible;
  const [loading, setLoading] = useState(false);
  const [deleteFile] = useMutation(deleteTrainingFileMutation);

  const onYes = useCallback(async () => {
    setLoading(true);
    try {
      await deleteFile({
        variables: {
          _id: trainingFile._id,
        },
      });
      notification.success({
        message: 'Deleted',
        description: 'File deleted successfully',
      });
      onFinish?.();
    } catch (err) {
      console.error(err);
      notification.error({
        message: 'Error',
        description: 'We apologize.  An error occurred.',
      });
    }
    setLoading(false);
  }, [trainingFile, deleteFile, onFinish]);

  return (
    <YesNoModalJ10
      title="Delete Training File"
      yesText="Delete"
      noText="Cancel"
      onYes={onYes}
      onNo={onCancel}
      visible={visible}
      loading={loading}
    >
      <Paragraph>Are you sure you want to delete this training file?</Paragraph>
      <Paragraph style={{ fontWeight: 600 }}>
        {trainingFile?.fileName}
      </Paragraph>
    </YesNoModalJ10>
  );
}

export default DeleteTrainingFileModal;
